import { memo, useCallback, useState } from "react";

import { TextField } from "ui/components/TextField/TextField";
import { VehicleDriverSearchFilterProps } from "./types";
import { FleetVehicleDriverSearchFormValues } from "services/api/fleet/vehicles/drivers/types";
import { initialFleetVehicleDriverSearchForm } from "services/api/fleet/vehicles/drivers/consts";
import { useTranslate } from "helpers";

const VehicleDriverSearchFilters: React.FC<VehicleDriverSearchFilterProps> = (
  props
) => {
  const { onSearchChange } = props;
  const { t } = useTranslate();

  const [formValues, setFormValues] =
    useState<FleetVehicleDriverSearchFormValues>(
      initialFleetVehicleDriverSearchForm
    );

  const handleSearchChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const updatedFormValues = { ...formValues, search: e.target.value };
    setFormValues(updatedFormValues);
    onSearchChange(updatedFormValues);
  };

  const handleResetFormClick = useCallback(() => {
    setFormValues(initialFleetVehicleDriverSearchForm);
  }, []);

  return (
    <>
      <div className="flex justify-between items-center ">
        <div className="flex">
          <div className="mr-3">
            <TextField
              type="text"
              name="search"
              value={formValues.search}
              onChange={handleSearchChange}
              placeholder={t("admin.search.placeholder")}
              startIcon="/media/icons/search.svg"
              cssClassName="bg-white"
            />
          </div>

          <div className="mr-3 flex items-center">
            <span
              onClick={handleResetFormClick}
              className="text-xs font-bold cursor-pointer text-gray-700"
            >
              {t("admin.reset")}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
export default memo(VehicleDriverSearchFilters);
